module.exports = __webpack_public_path__ + "img/block-chain-3955939_1920-lazy.3b10bc8e.jpg";